angular.module('FmsApp').factory("PlantingProgressReportFactory", ["$resource", function ($resource) {
    return $resource("api/v1.0/farm-reports/planting-progress/")
}]);